import makeStyles from '@mui/styles/makeStyles'
import {
  MyAccountTheme,
  MyAccountButtonSubmitClasses,
} from '@dxp-module/themes'

const miniWidgetbuttonSubmitStyles = makeStyles<
  MyAccountTheme,
  object,
  MyAccountButtonSubmitClasses
>(
  () => ({
    submitButtonContainer: {},
    btnContained: {},
    submitButton: {},
  }),
  { name: 'Signup_MiniWidgetButtonSubmit' }
)

export default miniWidgetbuttonSubmitStyles
